import type { FieldWidth, IFieldDefinition } from '@platform/core/types';
import { widthOf } from '@platform/core/lib/fieldTypes';

/** Поріг довгого варіанта (FORM_LAYOUT §3, GSET_DEFAULT.longOpt прототипу). */
const LONG_OPTION = 16;

/**
 * Ширина поля на сітці форми (UIUX/forms/field-grid-and-widths): явна ширина → список вибору M, якщо будь-який підпис варіанта
 * мовою інтерфейсу довший за 16 знаків, інакше S → решта правил платформи (widthOf).
 */
export function choiceWidth(field: IFieldDefinition, labels: string[]): FieldWidth {
  if (field.width) return field.width;
  if (field.type === 'select') return labels.some((l) => l.length > LONG_OPTION) ? 'M' : 'S';
  return widthOf(field);
}
